const headers = {
  name: "Project amenities",
  navigate: {
    path: [
      {
        name: "Amenities",
        path: "/app/projects/amenities",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
